import React from "react";
import {Button} from "antd";
import dayjs from "dayjs";

import {getBookingIncrement} from "../../helpers/booking";
import {messageType, showMessages} from "../../helpers/message";
import {BookingDetailsRequestDataType, BookingEndParams} from "../../types/bookingTypes";
import {useUpdateBookingMutation} from "../../store/api/bookingsApi";
import {BaseError} from "../../types/apiTypes";

const BookingEnd = ({bookingID}: BookingEndParams) => {
    const [updateBooking, {isSuccess, isError, error, isLoading}] = useUpdateBookingMutation();
    const bookingIncrement = getBookingIncrement();

    React.useEffect(() => {
        if (isSuccess) {
            showMessages('Trip has successfully been ended.', messageType.success);
        }
        if (isError) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error, isError, isSuccess]);

    const handleClick = async () => {
        let requestData: BookingDetailsRequestDataType = {};
        const nextIncrement = getNextIncrement();
        requestData['ended_at'] = nextIncrement.format('YYYY-MM-DD HH:mm:ssZZ');

        await updateBooking({bookingID, requestData});
    };

    const getNextIncrement = () => {
        const bookingIncrementMinutes = Number(bookingIncrement) / 60;
        const remainder = bookingIncrementMinutes - (dayjs().tz().minute() % bookingIncrementMinutes);
        return dayjs().tz().add(remainder, "minute").startOf('minute');
    };

    return (
        <Button danger htmlType='button' loading={isLoading} onClick={handleClick}>
            End Trip
        </Button>
    );
}

export default BookingEnd;
